export default class GameOverState {
	constructor(scene, stateMachine) {
		this.stateMachine = stateMachine;
		this.stateObject = scene;
		this.slotControls = scene.slotControls;
		this.spinButton = this.slotControls.slotSpinButton;
		this.autoSpinButton = this.slotControls.slotAutoSpinButton;
		this.guiController;
		this.slotPlayer = scene.slotPlayer;
		this.subState = null;
	}

	enterFrom(oldState) {
		console.log(this.toString() + ' - Enter From: ' + oldState.toString());

		if (this.spinButton !== null) {
			this.spinButton.longPressClickEvent.add(this.longPressSpin_Click, this);
			this.spinButton.clickEvent.add(this.spin_Click, this);
			this.spinButton.pointerDownEvent.add(this.spin_PointerDown, this);
			this.spinButton.longPointerDownEvent.add(this.spin_LongPointerDown, this);
		}

		if (this.autoSpinButton !== null) {
			this.autoSpinButton.clickEvent.add(this.autoSpin_Click, this);
		}

		this.slotControls.setControlActivity(false, false, false); // activity, spinButtonAcivity, autoSpinButtonAcivity
		this.stateObject.winController.winShowCancel();
		this.stateObject.winController.resetWin();
		this.stateObject.isFreeSpin = false;

		if (this.stateObject.isCascadeSpin) {
			// first cascade spin
			this.stateMachine.changeState(this.stateObject.spinState);
			return;
		}

		/*if (!this.slotControls.isAnyLineSelected()) {
			var mess = this.stateObject.guiController.showMessage('', 'Please select a any line.', this, () => {
				this.stateObject.guiController.closePopUp(mess);
			});
			this.stateMachine.changeState(this.stateObject.iddleState);
			return;
		}*/

		if (this.slotPlayer.coins === 0) {
			var mess = this.stateObject.guiController.showShare('Share', 'Game over.', this, () => {
				this.stateObject.guiController.closePopUp(mess);
			});
			if (this.slotControls.auto) this.slotControls.resetAutoSpinsMode();
			this.stateMachine.changeState(this.stateObject.iddleState);
			return;
		}

		console.log(this.toString() + '  - go to spin state');

		this.stateMachine.changeState(this.stateObject.spinState);
	}

	exitTo(newState) {
		if (this.spinButton !== null) {
			this.spinButton.longPressClickEvent.remove(this.longPressSpin_Click);
			this.spinButton.clickEvent.remove(this.spin_Click);
			this.spinButton.pointerDownEvent.remove(this.spin_PointerDown);
			this.spinButton.longPointerDownEvent.remove(this.spin_LongPointerDown);
		}
		if (this.autoSpinButton !== null) {
			this.autoSpinButton.clickEvent.remove(this.autoSpin_Click);
		}
	}

	//region input
	spin_PointerDown() {}

	spin_LongPointerDown() {}

	longPressSpin_Click() {}

	spin_Click() {}

	autoSpin_Click() {}
	//endregion input

	//region old
	handleInput() {
		handleInput();
	}

	physicsUpdate() {}
	//endregion old

	toString() {
		return 'GameOverState';
	}
}
